/**
 * Resolves the PocketBase base URL for fetch calls.
 *
 * In production the SPA is served from the same host as PB (api.skiffs.app),
 * so a relative URL (`/api/...`) just works. In `vite dev` we point at the
 * VITE_PB_URL override if set; otherwise we still try same-origin (the
 * developer can run a local PB on the same port via a proxy).
 */
export function pbBaseUrl(): string {
  const override = import.meta.env.VITE_PB_URL;
  if (override) return override.replace(/\/$/, '');
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
}
